import React from 'react'

const TopBadges = () => {
  return (
    <div className="">
        <div className='flex justify-center gap-2'>
          <div className="h-5 w-[15px] bg-light-secondary"></div>
          <div className="h-5 w-[15px] bg-light-secondary"></div>
          <div className="h-5 w-[15px] bg-light-secondary"></div>
        </div>
      </div>
  )
}

export default TopBadges
